<template>
  <div class="container">
    <div class="container-box">
      <slot name="txtBefore"></slot>
    </div>

    <div class="container-box">
      <div class="content-limiter">
        <slot name="txtBeforePersonalData"></slot>
        <div class="data-grid">
          <div class="col">
            <p class="label">Name des Anbieters</p>
            <p>{{ selectedKeys.providerKey }}</p>
          </div>
          <div class="col">
            <p class="label">Zu portierende Rufnummer</p>
            <p>{{ portationMsisdn }}</p>
          </div>
          <div class="col">
            <p class="label">Name im alten Vertrag</p>
            <p>{{ salutation(person.gender) }} {{ person.firstName }} {{ person.lastName }}</p>
          </div>
          <div class="col">
            <p class="label">Geburtstag im alten Vertrag</p>
            <p>{{ person.birthDate }}</p>
          </div>
        </div>

        <slot name="txtBeforePaymentInformation"></slot>

        <div v-if="paymentInformation" class="data-grid">
          <div v-if="!isNoPayment" class="col">
            <p class="label">Deine aktuelle Zahlungsart</p>
            <p>{{ isCreditCard ? 'Kreditkarte' : 'Lastschrift' }}</p>
          </div>
          <div v-if="!isNoPayment" class="col">
            <p class="label">{{ isCreditCard ? 'Kreditkarteninhaber' : 'Kontoinhaber' }}</p>
            <p>{{ isCreditCard ? paymentInformation.paymentType.holder : paymentInformation.paymentType.owner }}</p>
          </div>
          <div v-if="isBankAccount && !isNoPayment" class="col">
            <p class="label">IBAN</p>
            <p>*****{{ paymentInformation.paymentType.iban }}</p>
          </div>
          <div v-if="isCreditCard && !isNoPayment" class="col">
            <p class="label">Prüfnummern</p>
            <p>*****{{ paymentInformation.paymentType.lastDigits }}</p>
          </div>
        </div>
      </div>
    </div>

    <slot name="txtAfter"></slot>

    <div class="flex-justify-content-end">
      <a href="/mein-lidl-connect-v2/konto-service.html" class="button button--primary">Zurück zur Übersicht</a>
    </div>
  </div>
</template>
<script>
import { wrapQuery } from '@/helper/wrapGQLQuery'
import { mapGetters } from 'vuex'
import gql from 'graphql-tag'
import slotProxy from '@/mixins/slotProxy'

export const stepName = 'mnpInSuccess'

export default {
  data() {
    return {
      paymentInformation: {
        paymentType: {}
      }
    }
  },
  computed: {
    isNoPayment() {
      return this.paymentInformation.paymentType === null
    },
    isCreditCard() {
      if (this.paymentInformation.paymentType !== null) {
        return this.paymentInformation.paymentType.type === 'creditCard'
      }
      return false
    },
    isBankAccount() {
      if (this.paymentInformation.paymentType !== null) {
        return this.paymentInformation.paymentType.type === 'bankAccount'
      }
      return false
    },
    ...mapGetters('mnpIn', ['person', 'selectedKeys', 'portationMsisdn'])
  },
  methods: {
    salutation(gender) {
      switch (gender) {
        case 'MALE':
          return 'Herr'
        case 'FEMALE':
          return 'Frau'
      }
    }
  },
  mixins: [slotProxy()],
  apollo: {
    paymentInformation: function() {
      return wrapQuery(
        gql`
          query changePayment {
            paymentInformation {
              paymentType {
                ... on BankAccount {
                  type
                  iban
                  owner
                }
                ... on CreditCard {
                  type
                  holder
                  company
                  expiryMonth
                  expiryYear
                  lastDigits
                }
              }
            }
          }
        `,
        this,
        'paymentInformation'
      )
    }
  }
}
</script>
